import React, { useEffect, useState } from 'react';
import { CheckCircle2, RefreshCw } from 'lucide-react';

export function ReloadPrompt() {
  const [updateStatus, setUpdateStatus] = useState<'idle' | 'checking' | 'up-to-date'>('idle');
  
  // Check for updates every hour
  useEffect(() => {
    const interval = setInterval(async () => {
      if ('serviceWorker' in navigator) {
        try {
          const registrations = await navigator.serviceWorker.getRegistrations();
          for (const reg of registrations) {
            if (
              reg.active && 
              reg.active.scriptURL.includes('sw.js') && 
              !reg.active.scriptURL.includes('_service-worker')
            ) {
              await reg.update();
            }
          }
        } catch (error) {
          console.error('Error checking for SW updates automatically:', error);
        }
      }
    }, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const handleManualUpdateCheck = async () => {
    if (updateStatus !== 'idle') return;
    
    setUpdateStatus('checking');
    
    if ('serviceWorker' in navigator) {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const reg of registrations) {
          // Only update our PWA service worker, NOT the injected _service-worker.js
          if (
            reg.active && 
            reg.active.scriptURL.includes('sw.js') && 
            !reg.active.scriptURL.includes('_service-worker')
          ) {
            await reg.update();
          }
        }
      } catch (error) {
        console.error('Error checking for SW updates:', error);
      }
    }

    // Show "Buscando..." for 3 seconds, then "¡Estás al día!"
    setTimeout(() => {
      setUpdateStatus('up-to-date');
      setTimeout(() => {
        setUpdateStatus('idle');
      }, 3000);
    }, 3000);
  };

  return (
    <button
      onClick={handleManualUpdateCheck}
      disabled={updateStatus !== 'idle'}
      title="Buscar actualizaciones"
      className={`fixed bottom-2 left-2 z-50 flex items-center justify-center gap-1.5 p-2 transition-all duration-300 rounded-lg ${
        updateStatus === 'idle' 
          ? 'text-zinc-600 opacity-30 hover:opacity-100 hover:text-zinc-300 hover:bg-zinc-900/50' 
          : 'text-emerald-500 bg-zinc-900/80 backdrop-blur-sm border border-zinc-800/50 shadow-lg'
      }`}
    >
      {updateStatus === 'idle' && <RefreshCw className="w-3.5 h-3.5" />}
      {updateStatus === 'checking' && (
        <>
          <RefreshCw className="w-3.5 h-3.5 animate-spin" />
          <span className="text-[10px] font-medium pr-1 whitespace-nowrap">Buscando...</span>
        </>
      )}
      {updateStatus === 'up-to-date' && (
        <>
          <CheckCircle2 className="w-3.5 h-3.5" />
          <span className="text-[10px] font-medium pr-1 whitespace-nowrap">¡Estás al día!</span>
        </>
      )}
    </button>
  );
}
